import {Button, Toolbar, Typography, TextField} from "@mui/material";
import {ID} from "../../../../types/global.d";
import {Add, } from "@mui/icons-material";
import {useNavigate, useLocation} from "react-router";
import React from "react";
import {useStateSession} from "../../../../hooks/useAuth";
import { Trans } from "@lingui/react/macro";

type IFormProps = {
    showAdd: boolean,
    };

const BuyerListHeader = (props: IFormProps)  => {

    const {showAdd, onSearchTerm, ...query} = props;
    
    const session = useStateSession()
    const navigate = useNavigate();
    const routeLocation = useLocation();
    
    const onAdd = React.useCallback((e: any) => {
        e.stopPropagation()
        if (routeLocation.pathname.endsWith('buyers')) {
            navigate(`add`, {relative: 'route', state: query})
        } else {
            navigate(`buyers/add`, {relative: 'route', state: query})
        }
    }, [navigate, routeLocation])

    return (
        <Toolbar
            sx={ {
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            } }
        >
            <Typography
                sx={ { flex: '1 1 100%' } }
                variant="h6"
                component="div"
                data-testid="Buyer-list-title"
            >
                <Trans>Buyers</Trans>
            </Typography>
            { showAdd && session.hasPermission('', 'applications/timber/entities/Buyers/write/view') &&
                <Button data-testid="Buyer-add-button" variant="contained" color="success" startIcon={<Add />} onClick={onAdd}>
                    <Trans>Add</Trans>
                </Button>
            }
        </Toolbar>
    )
}
export default BuyerListHeader;
